import React from 'react';
import classNames from 'classnames';

export interface PageHeaderProps {
  children: React.ReactNode;
  variant?: 'default' | 'error';
  className?: string;
  id?: string;
  element?: 'h1';
}

const PageHeader = ({ children, variant = 'default', className, id, element }: PageHeaderProps): JSX.Element => {
  const renderPageHeader = () => {
    switch (element) {
      case 'h1':
        return <h1 className="grid-container ver-page-header__title">{children}</h1>;
      default:
        return <div className="grid-container ver-page-header__title">{children}</div>;
    }
  };

  return (
    <div
      id={id}
      className={classNames(className, 'ver-page-header', { 'ver-page-header--error': variant === 'error' })}
    >
      {renderPageHeader()}
    </div>
  );
};

export default PageHeader;
